import PocketBase from 'pocketbase'

const url = import.meta.env.VITE_POCKETBASE_URL as string

export const pb = new PocketBase(url)

/** Параллельные getList/getFullList не должны отменять друг друга (React Strict Mode, формы с несколькими загрузками). */
pb.autoCancellation(false)

/** Явно отключить dedupe/autocancel для отдельного запроса (если autoCancellation снова включат). */
export const PB_NO_CANCEL = { requestKey: null } as const
